import { useCallback } from 'react';
import type { SavedConfig } from '../types';

export const useNumberFormatConfig = (
  savedConfig: SavedConfig,
  updateSavedConfig: (newValue: SavedConfig) => void,
) => {
  const { areDecimalPlacesFixed, decimalSeparator, thousandsSeparator } = savedConfig;

  const onChangeAreDecimalPlacesFixed = useCallback(
    (v: boolean) => updateSavedConfig({ ...savedConfig, areDecimalPlacesFixed: v }),
    [savedConfig, updateSavedConfig],
  );

  const onChangeDecimalSeparator = useCallback(
    (v: string) => updateSavedConfig({ ...savedConfig, decimalSeparator: v }),
    [savedConfig, updateSavedConfig],
  );

  const onChangeThousandsSeparator = useCallback(
    (v: string) => updateSavedConfig({ ...savedConfig, thousandsSeparator: v }),
    [savedConfig, updateSavedConfig],
  );

  return {
    areDecimalPlacesFixed,
    decimalSeparator,
    thousandsSeparator,
    onChangeAreDecimalPlacesFixed,
    onChangeDecimalSeparator,
    onChangeThousandsSeparator,
  };
};
